// =============================================================================
// Scheduling — Zod schemas for delivery routing + production capacity
// =============================================================================
import { z } from 'zod';
import { regionSchema } from './sales.js';
export const dayOfWeekSchema = z.enum(['MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT', 'SUN']);
/**
 * Map of day-of-week → array of regions delivered on that day.
 * Days omitted from the map = no deliveries that day.
 * `center` typically appears on every active day.
 */
export const regionsByDayOfWeekSchema = z.record(dayOfWeekSchema, z.array(regionSchema));
/** PATCH body for /scheduling/config */
export const schedulingConfigUpdateSchema = z.object({
    regionsByDayOfWeek: regionsByDayOfWeekSchema.optional(),
    productionPerDay: z.coerce.number().int().min(1).max(1000).optional(),
    deliveriesPerDay: z.coerce.number().int().min(1).max(1000).optional(),
    productionLeadDays: z.coerce.number().int().min(0).max(60).optional(),
});
/** Read shape of the config (what GET /scheduling/config returns). */
export const schedulingConfigSchema = z.object({
    id: z.string(),
    companyId: z.string(),
    regionsByDayOfWeek: regionsByDayOfWeekSchema,
    productionPerDay: z.number().int(),
    deliveriesPerDay: z.number().int(),
    productionLeadDays: z.number().int(),
    updatedAt: z.string(),
});
/** POST/PATCH body for /scheduling/region-hints */
export const regionHintCreateSchema = z.object({
    city: z.string().min(1).max(200),
    region: regionSchema,
});
/** One day's delivery slot status — what GET /scheduling/delivery-availability returns. */
export const deliveryDayStatusSchema = z.object({
    date: z.string(), // YYYY-MM-DD
    eligible: z.boolean(), // day-of-week is on rotation for the region
    deliveriesScheduled: z.number().int(),
    deliveryCap: z.number().int(),
    atCapacity: z.boolean(),
    productionDate: z.string().nullable(), // date - leadDays (the natural production day)
    productionScheduled: z.number().int(), // units already booked for productionDate
    productionCap: z.number().int(),
});
//# sourceMappingURL=scheduling.js.map